(exports.GAME_ID = "61c33dac1a4fef00169cb125"),
(exports.FORM_ID = "61d4476b61ee580016f295f0"),
(exports.STATUS_FORM_ID = "604098955f01640015a8f8f1"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-dev");